import { areCustomEqual } from "../equality";
import React from "react";

var googletag = window.googletag;

var instanceCounter = 0;

export default class GooglePublisherTag extends React.Component {
  constructor(props) {
    super(props);

    // generate a unique id for each div for each instance of this component
    this.divId = "div-gpt-ad-1532633604989-" + instanceCounter;
    instanceCounter++;
  }

  componentDidMount() {
    var { adUnitPath, defaultHeight, defaultWidth, sizeMappings, targeting } = this.props;

    googletag.cmd.push(() => {
      this.slot = googletag.defineSlot(adUnitPath, [defaultWidth, defaultHeight], this.divId).
        defineSizeMapping(sizeMappings).
        addService(googletag.pubads());

      Object.keys(targeting).reduce((slot, key) => slot.setTargeting(key, targeting[key]), this.slot);

      // `display` has to be called before `refresh` and after the slot div is in the page.
      googletag.display(this.divId);
      googletag.pubads().refresh([this.slot]);
    });
  }

  shouldComponentUpdate(nextProps) {
    var { targeting } = this.props;
    return !areCustomEqual(targeting, nextProps.targeting);
  }

  componentDidUpdate() {
    var { targeting } = this.props;

    googletag.cmd.push(() => {
      this.slot.clearTargeting();
      Object.keys(targeting).reduce((slot, key) => slot.setTargeting(key, targeting[key]), this.slot);
      googletag.pubads().refresh([this.slot]);
    });
  }

  componentWillUnmount() {
    if (this.slot) {
      googletag.destroySlots([this.slot]);
      this.slot = undefined;
    }
  }

  render() {
    var { className } = this.props;

    return (
      <div
        className={className}
        id={this.divId}
        style={{display: "none"}} />
    );
  }
}
